import { useEffect } from 'react';

const TRAIL_LENGTH = 24;
const TRAIL_COLOR = '255, 199, 0';

export function useCursorTrail(canvasRef, cursorRef) {
  useEffect(() => {
    if (window.matchMedia('(pointer: coarse)').matches) return undefined;

    const cursor = cursorRef.current;
    const canvas = canvasRef.current;
    if (!cursor || !canvas) return undefined;

    const ctx = canvas.getContext('2d');
    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    const positions = [];
    let mouseX = -200;
    let mouseY = -200;
    let rafId;

    const onMouseMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      cursor.style.transform = `translate(${e.clientX - 12}px, ${e.clientY - 12}px)`;
    };

    const drawTrailPoint = (p, i, total) => {
      const t = 1 - i / total;
      ctx.beginPath();
      ctx.arc(p.x, p.y, Math.max(0.8, 3.5 * t), 0, Math.PI * 2);
      ctx.fillStyle = `rgba(${TRAIL_COLOR}, ${t * 0.55})`;
      ctx.fill();
    };

    const draw = () => {
      positions.unshift({ x: mouseX, y: mouseY });
      if (positions.length > TRAIL_LENGTH) positions.pop();

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      positions.forEach((p, i) => { if (i > 0) drawTrailPoint(p, i, positions.length); });

      rafId = requestAnimationFrame(draw);
    };

    document.addEventListener('mousemove', onMouseMove);
    rafId = requestAnimationFrame(draw);
    document.body.classList.add('custom-cursor-active');

    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      cancelAnimationFrame(rafId);
      window.removeEventListener('resize', resize);
      document.body.classList.remove('custom-cursor-active');
    };
    // Canvas trail mount effect: canvasRef/cursorRef are stable DOM handles, intentionally runs once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
